// ***********************************************************************
// Assembly         : Veriteq.Partner.Web
// Author           : Mike Palmer
// Created          : 06-21-2024
//
// Last Modified By : Mike Palmer
// Last Modified On : 06-21-2024
// ***********************************************************************
// <copyright file="_offcanvas.js" company="NSA Group Ltd">
//     Copyright (c) NSA Group Ltd. All rights reserved.
// </copyright>
// <summary>
//     JavaScript utilities for opening and closing Bootstrap offcanvas elements,
//     providing a simple API for toggling offcanvas components in a Blazor application.
// </summary>
// ***********************************************************************

window.offcanvas = window.offcanvas || {};

/**
 * Opens the Bootstrap offcanvas element with the specified ID.
 * This function retrieves or creates an offcanvas instance associated with the element
 * and triggers the display of the offcanvas panel.
 * 
 * @function open
 * @memberof window.offcanvas
 * @param {string} elementId - The ID of the offcanvas element to open.
 */
window.offcanvas.open = function (elementId) {
    const offcanvasElement = document.getElementById(elementId);

    if (offcanvasElement) {
        const offcanvas = window.bootstrap.Offcanvas.getOrCreateInstance(offcanvasElement);
        offcanvas.show();
    }
};

/**
 * Closes the Bootstrap offcanvas element with the specified ID.
 * This function retrieves or creates an offcanvas instance associated with the element
 * and triggers the hiding of the offcanvas panel.
 * 
 * @function close
 * @memberof window.offcanvas
 * @param {string} elementId - The ID of the offcanvas element to close.
 */
window.offcanvas.close = function (elementId) {
    const offcanvasElement = document.getElementById(elementId);

    if (offcanvasElement) {
        const offcanvas = window.bootstrap.Offcanvas.getOrCreateInstance(offcanvasElement);
        offcanvas.hide();
    }
};
